<!-- maxlength 6, not 1: iOS fills a one-time code (autocomplete="one-time-code") as one input
     event with the whole code, and maxlength 1 cut it to its first digit. useCodeBoxTyping
     spreads a whole code over the boxes, and keeps one digit when a box is typed over. -->
<template>
  <div ref="container" class="container">
    <label :for="getId(0)">Enter 6-digit code</label>
    <input
      v-for="(digit, index) in codeBoxContent"
      :id="getId(index)"
      :key="index"
      v-model="codeBoxContent[index]"
      type="text"
      maxlength="6"
      class="box"
      inputmode="numeric"
      pattern="[0-9]"
      :name="getName(index)"
      :aria-label="getAriaLabel(index)"
      :autocomplete="index === 0 ? 'one-time-code' : undefined"
      autocapitalize="none"
      spellcheck="false"
      @input="onDigitInput($event, index)"
      @keydown="onDigitKeydown($event, index)"
      @paste="handlePaste"
    />
  </div>
</template>

<script setup>
import {inject, onMounted} from "vue";
import {useCodeBoxShared} from "@/composables/useCodeBoxShared";
import {useCodeBoxTyping} from "@/composables/useCodeBoxTyping";
import {useCodeBoxPaste} from "@/composables/useCodeBoxPaste";

const verificationCode = inject("verificationCode");
const shared = useCodeBoxShared(verificationCode);
const {container, codeBoxContent, getName, getId, getAriaLabel, autoFocusFirstInput} = shared;
const {onDigitInput, onDigitKeydown} = useCodeBoxTyping(shared);
const {handlePaste} = useCodeBoxPaste(shared);

onMounted(() => autoFocusFirstInput());
</script>

<style scoped>
.container {
  --box-gap: 0.4rem;
  --box-width: calc((100% - (5 * var(--box-gap))) / 6);
  position: relative;
  display: flex;
  gap: var(--box-gap);
  justify-content: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: var(--space-medium, 1rem) 0;
  padding: 0 var(--space-xx-small, 0.25rem);
}
label {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
.box {
  box-sizing: border-box;
  width: var(--box-width) !important;
  aspect-ratio: 1;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 1.5rem;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.box:nth-of-type(3) {
  margin-right: var(--box-gap) !important;
}
.box:focus,
.box:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(120, 190, 255, 0.6);
}
</style>
